import { executeQuery } from 'common/gql';
import performOptInToHomeClubMutation from 'common/gql/mutation/homeclub/opt-in-home-club.gql';
import {
  dispatchHomeClubSectionClickEvent,
  HomeClubSectionEventMessage,
} from 'common/tracking/home-club';

interface PerformOptInToHomeClubVariables {
  subscribeButlersNewsletter: boolean;
}

interface OptInToHomeClubParams {
  buttonLabel: string;
  onSuccess: () => void;
  onFailedHomeClubOptIn: () => void;
}

const performOptInToHomeClub = (variables: PerformOptInToHomeClubVariables) =>
  executeQuery<void, PerformOptInToHomeClubVariables>(performOptInToHomeClubMutation, variables);

export const optInToHomeClub = async ({
  buttonLabel,
  onSuccess,
  onFailedHomeClubOptIn,
}: OptInToHomeClubParams) => {
  try {
    await performOptInToHomeClub({ subscribeButlersNewsletter: false });

    dispatchHomeClubSectionClickEvent({
      button_text: buttonLabel,
      event_message: HomeClubSectionEventMessage.Success,
    });

    onSuccess();
  } catch {
    dispatchHomeClubSectionClickEvent({
      button_text: buttonLabel,
      event_message: HomeClubSectionEventMessage.Failure,
    });

    onFailedHomeClubOptIn();
  }
};
